import React from 'react'
import { ClockIcon } from '@heroicons/react/24/outline'
import {
  dailyCronToTimeValue,
  formatDailyCronLabel,
  timeValueToDailyCron,
} from '../../utils/dailyCronSchedule'

export default function DailyRunTimeField({
  label,
  value,
  onChange,
  disabled = false,
  timezone,
  fallback = '08:30',
  hint,
}) {
  const handleChange = (timeValue) => {
    const cron = timeValueToDailyCron(timeValue)
    if (cron) onChange(cron)
  }

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        <ClockIcon className="w-4 h-4 inline mr-1" />
        {label}
      </label>
      <input
        type="time"
        value={dailyCronToTimeValue(value, fallback)}
        onChange={(e) => handleChange(e.target.value)}
        className="w-full max-w-xs px-3 py-2 border border-gray-300 rounded-md text-sm disabled:bg-gray-100 disabled:text-gray-500"
        disabled={disabled}
      />
      <p className="text-xs text-gray-500 mt-1">
        {hint || (value
          ? formatDailyCronLabel(value, { timezone })
          : `Defaults to ${formatDailyCronLabel(timeValueToDailyCron(fallback), { timezone })}`)}
      </p>
    </div>
  )
}
